import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ArrowLeft } from "lucide-react";

export default function AdminLoginPage() {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="min-h-screen bg-[#ffffff]" />;
  if (user && user !== false && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (!res.ok) setError(res.error || "Login failed");
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#ffffff] text-[#0a0a0a] flex flex-col">
      <div className="p-8">
        <Link to="/" className="inline-flex items-center gap-2 numeric text-xs uppercase tracking-widest text-black/50 hover:text-[#0a0a0a]">
          <ArrowLeft size={14} /> Back
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 -mt-16">
        <div className="w-full max-w-md">
          <div className="overline mb-3">Admin</div>
          <h1 className="font-display text-4xl font-light text-[#0a0a0a] tracking-tight">
            Sign in to <em className="not-italic text-[#121275]">Sold By 1st Choice Console</em>
          </h1>
          <form onSubmit={submit} className="mt-12 bg-[#f7f7f7] border border-black/10 p-8 space-y-6">
            <div>
              <label className="field-label">Email</label>
              <input
                type="email"
                required
                className="input-line"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email"
              />
            </div>
            <div>
              <label className="field-label">Password</label>
              <input
                type="password"
                required
                className="input-line"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password"
              />
            </div>
            {error && (
              <div data-testid="admin-login-error" className="text-red-400 text-sm font-mono">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-button"
              className="btn-primary w-full disabled:opacity-50"
            >
              {submitting ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
